// import { useState } from 'react';
import { initReactQueryAuth } from 'react-query-auth';

import { Spinner } from '@/components/Elements';
import {
  logout,
  loginWithUsernameAndPassword,
  getUser,
  registerWithEmailAndPassword,
  // UserResponse,
  LoginCredentialsDTO,
  RegisterCredentialsDTO,
  // AuthUser,
  UserInfo,
  LoginAPIResponse,
} from '@/features/auth';

// import storage from '@/utils/storage';

// const [user, setUser] = useState<null | UserInfo>(null);
interface Error {
  error: string;
}

async function handleUserResponse(data: LoginAPIResponse) {
  // const { jwt, user } = data.user_info;
  // storage.setToken(jwt);
  return data.user_info;
}

async function loadUser() {
  const data = await getUser();
  return data;
  // return null;
}

async function loginFn(data: LoginCredentialsDTO) {
  const response = await loginWithUsernameAndPassword(data);
  const user = await handleUserResponse(response);
  return user;
}

async function registerFn(data: RegisterCredentialsDTO) {
  const response = await registerWithEmailAndPassword(data);
  const user = await handleUserResponse(response);
  return user;
}

async function logoutFn() {
  // storage.clearToken();
  // window.sessionStorage.clear();

  await logout();


  // navigate to login page
  // window.location.href = '/auth/login';
}

const authConfig = {
  loadUser,
  loginFn,
  registerFn,
  logoutFn,
  LoaderComponent() {
    return (
      <div className="w-screen h-screen flex justify-center items-center">
        <Spinner size="xl" />
      </div>
    );
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
  UserInfo | null,
  Error,
  LoginCredentialsDTO,
  RegisterCredentialsDTO
>(authConfig);
